(() => {
  'use strict';
  const root = document.querySelector('[data-tinto-shop]');
  if (!root || root.dataset.tintoReady === 'true') return;
  root.dataset.tintoReady = 'true';

  const shell = root.querySelector('[data-tinto-shell]');
  const drawer = root.querySelector('[data-tinto-drawer]');
  const itemsNode = root.querySelector('[data-tinto-items]');
  const statusNode = root.querySelector('[data-tinto-status]');
  const subtotalNode = root.querySelector('[data-tinto-subtotal]');
  const totalNode = root.querySelector('[data-tinto-total]');
  const checkout = root.querySelector('[data-tinto-checkout]');
  const productTemplate = document.querySelector('main[data-template="product.tinto-genova"]');
  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let lastFocus = null;
  let cart = null;
  let busy = false;

  const localizePlatformLabels = () => {
    const morePaymentOptions = document.querySelector('.shopify-payment-button__more-options');
    if (morePaymentOptions && morePaymentOptions.textContent.trim() !== 'Más opciones de pago') {
      morePaymentOptions.textContent = 'Más opciones de pago';
    }
    const account = document.querySelector('shopify-account');
    const accountButton = account?.shadowRoot?.querySelector('button.account-button');
    if (accountButton?.getAttribute('aria-label') === 'Account') accountButton.setAttribute('aria-label', 'Cuenta');
  };

  localizePlatformLabels();
  customElements.whenDefined('shopify-account').then(() => {
    localizePlatformLabels();
    setTimeout(localizePlatformLabels, 500);
  });
  const labelObserver = new MutationObserver(localizePlatformLabels);
  labelObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => labelObserver.disconnect(), 10000);

  const nativeCartRoot = () => document.querySelector('theme-drawer#cart-drawer');
  const suppressNativeCart = () => {
    const nativeRoot = nativeCartRoot();
    if (!nativeRoot) return;
    const nativeDialog = nativeRoot.querySelector('dialog');
    if (nativeDialog?.open) nativeDialog.close();
    nativeRoot.removeAttribute('open');
    nativeRoot.setAttribute('aria-hidden', 'true');
  };

  document.documentElement.classList.add('tinto-custom-cart-enabled');
  suppressNativeCart();
  const nativeCartObserver = new MutationObserver(() => suppressNativeCart());
  nativeCartObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });

  const money = (cents) => new Intl.NumberFormat('es-CO', {
    style: 'currency', currency: 'COP', maximumFractionDigits: 0
  }).format(cents / 100).replace(/\s/g, ' ');

  const api = async (path, options = {}) => {
    const response = await fetch(`${routesRoot}${path}`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options
    });
    if (!response.ok) throw new Error('No pudimos actualizar el carrito. Inténtalo de nuevo.');
    return response.json();
  };

  const setStatus = (message = '') => { statusNode.textContent = message; };
  const setBusy = (value) => {
    busy = value;
    drawer.classList.toggle('tinto-is-loading', value);
    drawer.setAttribute('aria-busy', String(value));
  };

  const itemImage = (item) => item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
  const itemSubtitle = (item) => item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

  const render = (nextCart) => {
    cart = nextCart;
    itemsNode.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('div');
      empty.className = 'tinto-cart-empty';
      empty.innerHTML = '<p>Tu ritual está listo para comenzar.<br>Elige una presentación.</p>';
      itemsNode.append(empty);
    } else {
      cart.items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'tinto-cart-row';
        row.dataset.key = item.key;
        const image = document.createElement('img');
        image.src = itemImage(item);
        image.alt = '';
        image.width = 78;
        image.height = 92;
        image.loading = 'lazy';
        const copy = document.createElement('div');
        copy.className = 'tinto-cart-row__copy';
        const title = document.createElement('h3');
        title.textContent = item.product_title;
        const subtitle = document.createElement('p');
        subtitle.textContent = itemSubtitle(item);
        const qty = document.createElement('div');
        qty.className = 'tinto-qty';
        qty.setAttribute('aria-label', `Cantidad de ${item.product_title}`);
        qty.innerHTML = `<button type="button" data-tinto-qty="${item.quantity - 1}" aria-label="Disminuir cantidad de ${item.product_title}">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-tinto-qty="${item.quantity + 1}" aria-label="Aumentar cantidad de ${item.product_title}">+</button>`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'tinto-remove';
        remove.dataset.tintoQty = '0';
        remove.textContent = 'Eliminar';
        remove.setAttribute('aria-label', `Eliminar ${item.product_title}`);
        copy.append(title);
        if (subtitle.textContent) copy.append(subtitle);
        copy.append(qty, remove);
        const price = document.createElement('div');
        price.className = 'tinto-cart-row__price';
        price.textContent = money(item.final_line_price);
        row.append(image, copy, price);
        itemsNode.append(row);
      });
    }
    subtotalNode.textContent = money(cart.items_subtotal_price);
    totalNode.textContent = money(cart.items_subtotal_price);
    checkout.setAttribute('aria-disabled', String(!cart.items.length));
    checkout.tabIndex = cart.items.length ? 0 : -1;
    root.querySelectorAll('[data-tinto-upsell]').forEach((button) => {
      const included = cart.items.some((item) => String(item.variant_id) === button.dataset.tintoUpsell);
      button.disabled = included;
      button.textContent = included ? 'En el carrito' : 'Agregar';
    });
  };

  const refresh = async () => render(await api('cart.js'));

  const openDrawer = async (message = '') => {
    suppressNativeCart();
    if (shell.hidden) lastFocus = document.activeElement;
    shell.hidden = false;
    document.documentElement.classList.add('tinto-lock');
    document.body.classList.add('tinto-lock');
    setStatus(message);
    try { await refresh(); }
    catch (_) { setStatus('No pudimos cargar el carrito. Inténtalo de nuevo.'); }
    suppressNativeCart();
    queueMicrotask(suppressNativeCart);
    setTimeout(suppressNativeCart, 100);
    requestAnimationFrame(() => drawer.focus({ preventScroll: true }));
  };

  const closeDrawer = () => {
    if (shell.hidden) return;
    shell.hidden = true;
    document.documentElement.classList.remove('tinto-lock');
    document.body.classList.remove('tinto-lock');
    setStatus('');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  };



  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add') return;
    suppressNativeCart();
    event.promise?.then(({ detail }) => {
      suppressNativeCart();
      if (!detail?.didError) openDrawer('Producto agregado a tu ritual.');
    }).catch(() => suppressNativeCart());
  }, true);

  window.addEventListener('click', (event) => {
    const cartControl = event.composedPath().find((node) => node instanceof Element && node.matches('a[href="/cart"], a[href$="/cart"], button[aria-label*="Cart" i], button[aria-label*="Carrito" i], [role="button"][aria-label*="Cart" i], [role="button"][aria-label*="Carrito" i]'));
    if (!cartControl || root.contains(cartControl)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressNativeCart();
    if (shell.hidden) openDrawer();
  }, true);

  const add = async (variantId, quantity, label, trigger) => {
    const normalizedQuantity = Math.max(1, Number(quantity) || 1);
    if (busy) return;
    setBusy(true);
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    try {
      await api('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variantId), quantity: normalizedQuantity }] }) });
      await openDrawer(`${label} se agregó a tu ritual.`);
    } catch (_) {
      if (shell.hidden) shell.hidden = false;
      document.documentElement.classList.add('tinto-lock');
      document.body.classList.add('tinto-lock');
      setStatus('No pudimos agregar el producto. Inténtalo de nuevo.');
      requestAnimationFrame(() => drawer.focus({ preventScroll: true }));
    } finally {
      setBusy(false);
      if (trigger) trigger.removeAttribute('aria-busy');
    }
  };

  const productForm = () => document.querySelector('main[data-template="product.tinto-genova"] form[action*="/cart/add"]');
  const productSelection = (preferredVariant) => {
    const form = productForm();
    if (!form) return { variantId: preferredVariant, quantity: 1 };
    const data = new FormData(form);
    return {
      variantId: preferredVariant || data.get('id'),
      quantity: data.get('quantity') || 1
    };
  };

  document.addEventListener('submit', (event) => {
    if (!productTemplate || !event.target.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const selected = productSelection();
    const variantLabel = document.querySelector('main[data-template="product.tinto-genova"] input[type="radio"]:checked')?.value || 'Tu presentación';
    add(selected.variantId, selected.quantity, variantLabel, event.submitter);
  }, true);

  document.addEventListener('click', (event) => {
    const stickyButton = productTemplate && event.target.closest('sticky-add-to-cart [ref="addToCartButton"]');
    if (stickyButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const sticky = stickyButton.closest('sticky-add-to-cart');
      const selected = productSelection(sticky?.dataset.currentVariantId);
      const label = sticky?.querySelector('[data-testid="sticky-variant-title"]')?.textContent.trim() || 'Tu presentación';
      add(selected.variantId, selected.quantity, label, stickyButton);
      return;
    }

    const addButton = event.target.closest('[data-tinto-add], [data-tinto-upsell]');
    if (addButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      add(addButton.dataset.tintoAdd || addButton.dataset.tintoUpsell, 1, addButton.dataset.tintoLabel, addButton);
      return;
    }
    const close = event.target.closest('[data-tinto-close]');
    if (close) { event.preventDefault(); event.stopImmediatePropagation(); closeDrawer(); return; }
    const qty = event.target.closest('[data-tinto-qty]');
    if (qty) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const row = qty.closest('[data-key]');
      setBusy(true);
      api('cart/change.js', { method: 'POST', body: JSON.stringify({ id: row.dataset.key, quantity: Number(qty.dataset.tintoQty) }) })
        .then((next) => {
          render(next);
          setStatus(Number(qty.dataset.tintoQty) === 0 ? 'Producto eliminado.' : 'Cantidad actualizada.');
        })
        .catch(() => setStatus('No pudimos actualizar la cantidad. Inténtalo de nuevo.'))
        .finally(() => setBusy(false));
      return;
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (shell.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el) => !el.hidden && el.offsetParent !== null);
    if (!focusable.length) { event.preventDefault(); drawer.focus(); return; }
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const carousel = document.querySelector('[data-tinto-carousel]');
  const previous = document.querySelector('[data-tinto-prev]');
  const next = document.querySelector('[data-tinto-next]');
  if (carousel && previous && next) {
    const scrollCards = (direction) => {
      const card = carousel.querySelector('[data-tinto-card]');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(carousel).columnGap || '16');
      carousel.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => scrollCards(-1));
    next.addEventListener('click', () => scrollCards(1));
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); scrollCards(event.key === 'ArrowRight' ? 1 : -1); }
    });
  }

  checkout.addEventListener('click', (event) => { if (!cart || !cart.items.length) event.preventDefault(); });
})();
